import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { verifyEmail } from "supertokens-web-js/recipe/emailverification";
import { Loader2 } from "lucide-react";
import toast, { Toaster } from "react-hot-toast";

async function consumeVerificationCode(token, tenantId, navigate) {
  try {
    const response = await verifyEmail();
    if (response.status === "EMAIL_VERIFICATION_INVALID_TOKEN_ERROR") {
      toast.error("Verification link expired. Please try again.");
      navigate("/auth/verify-email");
    } else {
      toast.success("Email verified successfully!");
      navigate("/home");
    }
  } catch (err) {
    if (err.isSuperTokensGeneralError === true) {
      toast.error(err.message);
    } else {
      toast.error("Oops! Something went wrong.");
    }
  }
}

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");
  const tenantId = searchParams.get("tenantId");

  useEffect(() => {
    if (token) {
      consumeVerificationCode(token, tenantId, navigate);
    } else {
      toast.error("Invalid verification link.");
      navigate("/verify-email");
    }
  }, [token, tenantId, navigate]);

  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <Toaster />
      <Loader2 className="w-10 h-10 animate-spin" />
      <p className="mt-4 text-gray-700">Verifying your email...</p>
    </div>
  );
}
